"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transactionSigningSelector = void 0;
const transactionSigningSelector = (state) => state.transactionSigning;
exports.transactionSigningSelector = transactionSigningSelector;
